import { Form } from "react-bootstrap";
import "./LabelAndTextBox.css";
import React, { useState, useEffect } from "react";

interface LabelAndTextProps {
  title: string;
  defaultValue?: number | null;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const NumberBox = ({ defaultValue = 0, title, onChange, disabled = false }: LabelAndTextProps) => {
  const [value, setValue] = useState<string>((defaultValue ?? 0).toString());

  // Sync state if defaultValue changes from outside
  useEffect(() => {
    setValue((defaultValue ?? 0).toString());
  }, [defaultValue]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputVal = event.target.value;

    if (inputVal.startsWith("-")) {
      setValue("0");
      onChange(0);
      return;
    }

    setValue(inputVal);

    const parsed = inputVal === "" ? 0 : parseFloat(inputVal);
    if (Number.isNaN(parsed)) {
      onChange(0);
      return;
    }

    onChange(Math.max(0, parsed));
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (["-", "+", "e", "E"].includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleFocus = () => {
    if (value === "0") {
      setValue("");
    }
  };

  const handleBlur = () => {
    if (value.trim() === "") {
      setValue("0");
    }
  };

  return (
    <Form.Group className={disabled ? "disabled" : ""}>
      <Form.Label className="fw-bold fs-6 mt-2">{title}:</Form.Label>
      <Form.Control
        className="number"
        type="number"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onBlur={handleBlur}
        min={0}
        disabled={disabled}
      />
    </Form.Group>
  );
};

export default NumberBox;
